function createId(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return `pd-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
}

export const planningSessionId = createId();
export const createPlanningReportId = createId;
